import type { OrderDetailsColumns, OrderDetailsFieldView } from '@src/features/orders/details/types';

const FIRST_COLUMN_KEYS = ['email', 'account-type', 'first-name', 'last-name', 'country', 'corporate-name'];
const SECOND_COLUMN_KEYS = ['document', 'phone', 'payment-method', 'installments', 'zip-code'];

const pick = (fields: OrderDetailsFieldView[], keys: string[]): OrderDetailsFieldView[] =>
  keys
    .map((key) => fields.find((field) => field.key === key))
    .filter((field): field is OrderDetailsFieldView => !!field);

export const buildOrderDetailsColumns = (fields: OrderDetailsFieldView[]): OrderDetailsColumns => {
  const known = [...FIRST_COLUMN_KEYS, ...SECOND_COLUMN_KEYS];
  const knownSet = new Set(known);
  const unknown = fields.filter((field) => !knownSet.has(field.key));

  return [pick(fields, FIRST_COLUMN_KEYS), [...pick(fields, SECOND_COLUMN_KEYS), ...unknown]];
};
